import Swiper from 'swiper';
import {
  Navigation,
  Thumbs
} from 'swiper';


if (document.querySelector('.configurator--photoviewer--pv--wrapper-single')) {
  const pv = new ProductViewer({
    element: document.getElementById('pv-singleProduct'),
    imagesViaLink: true,
    images: JSON.parse(document.getElementById('pv-singleProduct').dataset.images),
    numberOfImages: 12,
    invertMovement: true,
    autoRotate: true
  });
} else {

  Swiper.use([Navigation, Thumbs]);
  const hasThumbs = document.querySelector('.product-thumbnails') ? true : false;
  if (hasThumbs) {
    var swiper = new Swiper(".product-thumbnails", {
      loop: false,
      slidesPerView: 5,
      spaceBetween: 16,
      freeMode: true,
      watchSlidesProgress: true,
    });
  }

  var swiper2 = new Swiper(".product-featured-image", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next-featured",
      prevEl: ".swiper-button-prev-featured",
    },
    thumbs: hasThumbs ? {
      swiper: swiper,
    } : {},
  });
}